import HeaderActions from '@swarm/ui/swarm/HeaderActions'
import { useTranslation } from 'react-i18next'

import Layout from 'src/components/Layout'
import Staking from 'src/components/Staking'
import StakingSubheader from 'src/components/Staking/StakingSubheader'

const StakingPage = () => {
  const { t } = useTranslation('staking')

  return (
    <Layout
      header={t('header')}
      subheader={<StakingSubheader />}
      scrollable
      headerActions={<HeaderActions smtWidget />}
    >
      <Staking />
    </Layout>
  )
}

export default StakingPage
